import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #MODAL
\*------------------------------------ */
dialog {
  position: unset;
  inset: unset;
  width: unset;
  height: unset;
  margin: unset;
  border: unset;
  padding: unset;
  color: unset;
  background-color: unset;
  overflow: unset;
  all: unset;
  user-select: text;
}

/**
* 1) Modal for displaying popup content such as email subscribe form
*/
.cat-c-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  inset-block-start: 0;
  inset-inline-start: 0;
  z-index: var(--cat-z-index-500);
  opacity: 0;
  visibility: hidden;
  background-color: var(--cat-theme-color-background-transparent-dim);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
  * Modal active state
  * 1) Make this visible and apply the proper background shadow
  */
}
.cat-c-modal.cat-is-active {
  opacity: 1;
  visibility: visible;
}

/**
* Full width modal
* 1) Modal with window that spans the full width of the viewport
*/
.cat-c-modal--full-width {
  height: auto;
}

/**
 * Modal window
 * 1) Full screen on small screens becomes a horizontally and vertically centered box on large screens
 */
.cat-c-modal__window {
  display: flex;
  flex-direction: column;
  position: fixed;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  transform: translate(var(--rtlTranslateX, -50%), -50%);
  height: auto;
  width: calc(var(--size-base-unit) * 56);
  max-width: calc(100% - calc(var(--size-base-unit) * 4));
  max-height: calc(100% - calc(var(--size-base-unit) * 6));
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  background: var(--cat-theme-color-background-default);
  transition: opacity var(--cat-anim-fade-quick) var(--cat-anim-ease);
  border-radius: var(--cat-border-radius-lg);
  box-shadow: var(--cat-theme-box-shadow-lg);
  z-index: var(--cat-z-index-300);
  /**
   * Fade the modal in when the modal state is open
   */
  /**
   * Modal window within full width modal
   */
}
.cat-c-modal.cat-is-active .cat-c-modal__window {
  opacity: 1;
  visibility: visible;
  outline: none;
}
.cat-c-modal--full-width .cat-c-modal__window {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  box-shadow: none;
  border-radius: 0;
  inset-block-start: 0;
  inset-inline-start: 0;
  transform: translate(0, 0);
}
.cat-c-modal--lg .cat-c-modal__window {
  width: calc(var(--size-base-unit) * 126);
}
.cat-c-modal--md .cat-c-modal__window {
  width: calc(var(--size-base-unit) * 85);
}

/**
 * Wrapper of header, body and footer
 * 1) Enable overflow for modal on small screens 
 */
.cat-c-modal__wrapper {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  /* 1 */
  overflow: auto;
}

/**
 * Modal header, modal body, and modal footer
 */
.cat-c-modal__header,
.cat-c-modal__body,
.cat-c-modal__footer {
  padding: var(--cat-space-medium);
}

/**
 * Modal header
 1) The wrapper for the content in the modal header
 */
.cat-c-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

/**
 * Modal header content
 * 1) The wrapper for content in a slot or cat heading
 */
.cat-c-modal__header-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-basis: 100%;
}

/**
 * Modal heading
 1) Show only two lines in the header.
 */
.cat-c-modal__heading {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/**
 * Modal body
 1) The modal body fills to the height of the parent container 
    when width is below 375px or height is below 320px
 */
.cat-c-modal__body {
  flex-basis: 100%;
  overflow: auto;
}
@media all and (width <= calc(23.4375rem - 0.02px)), (height <= calc(23.4375rem - 55px - 0.02px)) {
  .cat-c-modal__body {
    overflow: visible;
  }
}

/**
 * Modal close button
 1) The button that appears after the heading
 */
.cat-c-modal__close-button {
  margin-inline-start: var(--cat-space-x-small);
}

/**
 * Modal back button
 1) The button that appears before the heading
 */
.cat-c-modal__back-button {
  margin-inline-end: var(--cat-space-x-small);
}

/**
 * 1) Disable overflow for bottom wrapper on small screens so that parent modal wrapper overflows 
      when width is below 375px or height is below 320px
 */
.cat-c-modal--bottom-wrapper {
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1 1 0%;
}
@media all and (width <= calc(23.4375rem - 0.02px)), (height <= calc(23.4375rem - 55px - 0.02px)) {
  .cat-c-modal--bottom-wrapper {
    overflow: visible; /* 1 */
  }
}

/**
 * modal Orientation Bottom
 * modal style in mobile view
 */
.cat-c-modal--orientation-bottom .cat-c-modal__window {
  height: auto;
  inset-block: auto 0;
  transform: translate(0, 100%);
  inset-inline: 0;
  max-width: 100%;
  width: 100vw;
  border-radius: var(--cat-border-radius-lg) var(--cat-border-radius-lg) 0 0;
}
.cat-c-modal--orientation-bottom.cat-is-active .cat-c-modal__window {
  transform: translate(0, 0);
  box-shadow: var(--cat-box-shadow-bottom-drawer);
}
.cat-c-modal--orientation-bottom .cat-c-modal__body {
  overflow: visible;
}

.cat-c-modal--vertical-height-default .cat-c-modal__window {
  max-height: 50vh;
}

.cat-c-modal--vertical-height-large .cat-c-modal__window {
  max-height: 90vh;
}

.cat-c-modal:not(.cat-c-modal--has-header) [name=header], .cat-c-modal:not(.cat-c-modal--has-actions) [part=part-actions], .cat-c-modal:not(.cat-c-modal--has-footer) .cat-c-modal__footer {
  display: none;
}
`;
       